<template>
	<div class="country-graph">
		<div
			ref="countryGraph"
			style="width: 100%; height: 100%; overflow: hidden"
		></div>
	</div>
</template>

<script>
const eCharts = require("echarts");
export default {
	name: "countryGraph",
	props: {
		TotalCountryData: Array,
		showGraphByCountry: Boolean,
	},
	data() {
		return {
			ByConsolidatedGraphInstance: null,
			option: {
				dataZoom: [
					{
						show: false,
						startValue: 0,
						endValue: 9,
						height: 20,
						zoomLock: true,
						zoomOnMouseWheel: false,
						moveOnMouseMove: false,
						moveOnMouseWheel: true,
						preventDefaultMouseMove: true,
					},
					{
						height: 15,
						type: "slider",
						startValue: 0,
						endValue: 100,
						zoomLock: true,
						labelFormatter: "",
						moveOnMouseWheel: true,
					},
					{
						show: false,
						yAxisIndex: 0,
						filterMode: "empty",
						width: 30,
						height: "100%",
						showDataShadow: false,
						zoomLock: true,
						left: "93%",
					},
				],
				color: ["#003546", "#F37413"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
				},
				grid: {
					right: "10%",
					containLabel: true,
				},
				legend: {
					data: ["Total", "Average Score %"],
					textStyle: {
						fontSize: "13",
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: {
							alignWithLabel: true,
						},
						axisLabel: {
							interval: 0,
							rotate: 37, //If the label names are too long you can manage this by rotating the label.
							overflow: "truncate",
							margin: 8,
							hideOverlap: true,
							align: "right",
							verticalAlign: "top",
							lineHeight: 6,
							formatter: (value) => {
								if (value.includes("__")) {
									let labelArr = value.split("__");
									return `${this.excerptText(this.titleCase(labelArr[0]), 15)}\n
						${this.excerptText(this.titleCase(labelArr[1]), 15)}`;
								} else {
									return this.excerptText(value, 15);
								}
							},
						},
						boundaryGap: true,
						data: [1, 2, 3, 4, 5, 6],
						textStyle: {
							fontSize: "14",
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "",
						position: "left",
						alignTicks: false,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value}",
						},
					},
					{
						min: 0,
						max: 100,
						type: "value",
						name: "",
						position: "right",
						alignTicks: false,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value}%",
						},
					},
				],
				series: [
					{
						label: {
							normal: {
								show: true,
								position: "top",
								fontSize: 9,
								color: "#000000", // Set the color of the label text
								formatter: "{c}", // Display the value of the data point
							},
						},
						name: "Total",
						barGap: "10%",
						barCategoryGap: "10%",
						type: "line",
						groupPadding: 10,
						yAxisIndex: 0,
						barWidth: "24%",
						data: [5, 7, 3, 8, 6, 4],
						showBackground: false,
						itemStyle: {
							normal: {
								barBorderRadius: [0, 0, 0, 0],
							},
						},
						areaStyle: {
							color: "rgba(0, 69, 69, 0.2)", // Customize the color and transparency
						},
					},
					{
						label: {
							normal: {
								show: true,
								position: "top",
								fontSize: 9,
								color: "#000000", // Set the color of the label text
								formatter: "{c}", // Display the value of the data point
							},
						},
						name: "Average Score %",
						barGap: "10%",
						barCategoryGap: "10%",
						type: "line",
						groupPadding: 10,
						yAxisIndex: 0,
						barWidth: "24%",
						showBackground: false,
						data: [3, 5, 9, 2, 6, 8],
						itemStyle: {
							normal: {
								barBorderRadius: [0, 0, 0, 0],
							},
						},
					},
				],
			},
		};
	},
	watch: {
		showGraphByCountry(val) {
			if (val) {
				this.initGraph();
			}
		},
	},
	methods: {
		excerptText(text, length = 10, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		},
		initGraph() {
			let labelsData = [...this.TotalCountryData].map((el) => el.name);
			let total = [...this.TotalCountryData].map(
				(el) => el["completed_score_%"]
			);

			let completed = [...this.TotalCountryData].map((el) => el.completed);
			labelsData.unshift("April");
			total.unshift(0);
			completed.unshift(0);
			this.option.xAxis[0].data = labelsData;
			this.option.series[1].data = total;
			this.option.series[0].data = completed;
			const chartContainer = this.$refs.countryGraph;
			this.ByConsolidatedGraphInstance = eCharts.init(chartContainer);
			this.ByConsolidatedGraphInstance.setOption(this.option);
			this.$emit("emitshowGraphbyCountry");
			this.$forceUpdate();
		},
	},
};
</script>

<style>
.country-graph {
	height: 350px;
	width: 112% !important;
	margin-left: -100px !important;
}
.country-graph > div {
	background: #ffffff;
	position: relative;
	height: 100%;
	overflow: hidden;
}
</style>
